import React from 'react';
import { Drawer, Form, Button } from 'rsuite';
import { useDispatch } from 'react-redux';
import { updateServiceLine } from './../../../services/serviceline.service';
import { useTranslation } from 'react-i18next';






interface EditDrawerViewProps {
  open: boolean;
  onClose: () => void;
  department: any;
}

const EditDrawerView: React.FC<EditDrawerViewProps> = ({ open, onClose, department }) => {
  const dispatch = useDispatch();
  const [formValue, setFormValue] = React.useState({
    serviceLine: department?.serviceLine || ''
  });

  React.useEffect(() => {
    if (department) {
      setFormValue({
        serviceLine: department.serviceLine || ''
      });
    }
  }, [department]);

  const handleSubmit = () => {
    if (department?._id) {
      dispatch(updateServiceLine(department._id, formValue));
    }
    onClose();
  };
  const { t } = useTranslation();

  return (
    <Drawer backdrop="static" size="sm" placement="right" onClose={onClose} open={open}>
      <Drawer.Header>
        <Drawer.Title>{t('Edit Team')}</Drawer.Title>
        <Drawer.Actions>
          <Button onClick={handleSubmit} appearance="primary">
            {t('Save')}
          </Button>
          <Button onClick={onClose} appearance="subtle">
            {t('Cancel')}
          </Button>
        </Drawer.Actions>
      </Drawer.Header>

      <Drawer.Body>
        <Form fluid formValue={formValue} onChange={setFormValue}>
          <Form.Group>
            <Form.ControlLabel>{t('Team Name')}</Form.ControlLabel>
            <Form.Control name="serviceLine" placeholder={t("Enter team name")} />
          </Form.Group>
        </Form>
      </Drawer.Body>
    </Drawer>
  );
};

export default EditDrawerView;
